import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import PropTypes from "prop-types";
import Immersive3dTourFloor from "./Immersive3dTourFloor";
import Immersive3dTourFloorModel from "../../models/Immersive3dTourFloor";
import DnDItem, { DisplayTypes } from "~/components/element/DnDItem";

@observer
class Immersive3dTourFloorList extends Component {
  render() {
    const {
      floors,
      floorsDisabled,
      draggingPanoramaId,
      onFloorHoverCallback,
      onPanoramaDragBeginCallback,
      onPanoramaDragEndCallback,
      deletePanoramaCallback,
      onPanoramaClick,
      openProcessingImageModalCallback,
      floorNameChangeCallback,
      thumbnails,
      selectedPanoramasCount,
      onFloorDelete,
    } = this.props;

    if (floorsDisabled && floors.length > 1) {
      throw new Error(`Did not expected more than one floor  when  floors are disabled. Got: ${floors.length}`);
    }

    return (
      <div className="floors">
        {floors.map(floor => (
          <DnDItem
            key={floor.id}
            as={Immersive3dTourFloor}
            displayType={DisplayTypes.LIST}
            // Will be used by DnDItem
            disabled={floorsDisabled}
            // will be captured  at the Immersive3dTourFloor and used for the Panorama dnd item.
            floorsDisabled={floorsDisabled}
            floor={floor}
            remainingFloors={floors.filter(f => f.id !== floor.id)}
            onDelete={onFloorDelete}
            deletePanoramaCallback={panoramaId => deletePanoramaCallback(panoramaId)}
            openProcessingImageModalCallback={currentImageUrl => openProcessingImageModalCallback(currentImageUrl)}
            item={observable({
              id: floor.id,
              type: "floor",
              accept: ["floor", "panorama"],
            })}
            onHover={onFloorHoverCallback}
            onPanoramaDragBeginCallback={onPanoramaDragBeginCallback}
            onPanoramaDragEndCallback={onPanoramaDragEndCallback}
            onPanoramaClick={onPanoramaClick}
            floorNameChangeCallback={floorNameChangeCallback}
            thumbnails={thumbnails}
            draggingPanoramaId={draggingPanoramaId}
            selectedPanoramasCount={selectedPanoramasCount}
          />
        ))}
      </div>
    );
  }
}

Immersive3dTourFloorList.propTypes = {
  floors: PropTypes.arrayOf(PropTypes.instanceOf(Immersive3dTourFloorModel)),
  floorsDisabled: PropTypes.bool,
  onFloorHoverCallback: PropTypes.func.isRequired,
  onPanoramaDragBeginCallback: PropTypes.func.isRequired,
  onPanoramaDragEndCallback: PropTypes.func.isRequired,
  deletePanoramaCallback: PropTypes.func.isRequired,
  onPanoramaClick: PropTypes.func.isRequired,
  openProcessingImageModalCallback: PropTypes.func.isRequired,
  floorNameChangeCallback: PropTypes.func.isRequired,
  thumbnails: PropTypes.object.isRequired,
  draggingPanoramaId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedPanoramasCount: PropTypes.number.isRequired,
  onFloorDelete: PropTypes.func.isRequired,
};

export default Immersive3dTourFloorList;
